export default __webpack_public_path__ + "static/media/marvel-wolverine.ee676488.jpg";